/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Hotspot service
 */
namespace Application.Services {
    'use strict';
    
    import Hotspot = Models.Hotspot;
    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import IHalElement = Models.IHalElement;
    
    /**
     * HotspotService
     */
    export class HotspotService {
        public static $name: string = "hotspotService";
        public static $inject: string[] = ['backendService'];
        
        private backendService: BackendService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'hotspots/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'hotspots';
        
        constructor(backendService: BackendService) {
            this.backendService = backendService;
        }

        public getHotspotById(hotspotId: number, callback: (result: Hotspot) => void): void {
            this.getHotspotPromiseById(hotspotId).then(
                (element: Hotspot) => {
                    this.burnishHotspot(element);
                    callback(element);
                }
            );
        }
        
        public getAllPaginatedHotspots(callback: (messages: Models.IPaginatedList<Hotspot>) => void,
                                       page?: number, size?: number, sort?: String): void {
            let url: string = this.backendUrl + '?';
            url = page ? url += '&page=' + page : url;
            url = size ? url += '&size=' + size : url;
            url = sort ? url += '&sort=' + sort : url;
            this.backendService
                .get(url, true)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<Hotspot>>) => {
                    let convertedList: Models.IPaginatedList<Hotspot>;
                    convertedList = HalConverter.convertPaginatedList(result.data, Hotspot.Empty);
                    callback(convertedList);
                    convertedList.elements.forEach(
                        (element: Hotspot) => {
                            this.burnishHotspot(element);
                        }
                    );
                });
        }

        public getAllHotspotsPromise(): ng.IPromise<Hotspot[]> {
            return this.backendService
                .get(this.backendUrl)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<Hotspot>>) => {
                    let halElement: IHalList<Hotspot> = result.data;
                    let converted: Hotspot[] = HalConverter.convertList(halElement, Hotspot.Empty);
                    converted.forEach((element: Hotspot) => {
                            this.burnishHotspot(element);
                    });
                    return converted;
                });
        }

        public saveHotspot(hotspot: Application.Models.IHotspot): ng.IPromise<Models.IHotspot> {
            if (!hotspot.href || hotspot.href === undefined || hotspot.href === '') {
                return this.createHotspot(hotspot);
            } else {
                return this.updateHotspot(hotspot);
            }
        }

        public createHotspot(hotspot: Application.Models.IHotspot): ng.IPromise<Models.IHotspot> {
            return this.backendService
                .post(this.backendUrl, hotspot)
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.IHotspot>>) => {
                    let halElement: IHalElement<Hotspot> = result.data;
                    let converted: Hotspot = HalConverter.convertElement(halElement, Models.Hotspot.Empty);                     
                    return this.burnishHotspot(converted);
                 });
        }

        public updateHotspot(hotspot: Application.Models.IHotspot): ng.IPromise<Models.IHotspot> {            
            return this.backendService
                .put(hotspot.href, {
                    name: hotspot.name,
                    creationDate: hotspot.creationDate,
                    networkInterfaces: hotspot.networkInterfaces,
                    ssid: hotspot.ssid,
                    owner: hotspot.owner,
                    duration: hotspot.duration,
                    physicalLocation: hotspot.physicalLocation,
                    geoElement : hotspot.geoElement,
                    /* tslint:disable */
                    x: hotspot.x ? hotspot.x : null,
                    y: hotspot.y ? hotspot.y : null,
                    /* tslint:enable */
                })
                .then ((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.IHotspot>>) => {
                    let halElement: IHalElement<Hotspot> = result.data;
                    let converted: Hotspot = HalConverter.convertElement(halElement, Hotspot.Empty);
                    return this.burnishHotspot(converted);
                 }
            );
        }

        public deleteHotspot(hotspot: Application.Models.IHotspot): ng.IPromise<Models.IHotspot> {
            return this.backendService.delete(hotspot.href);
        }

        public addPositionToHotspot(href: string, x: number, y: number): ng.IPromise<Hotspot> {
            return this.getHotspotPromise(href).then(
                (hotspot: Hotspot) => {
                    hotspot.x = x;
                    hotspot.y = y;
                    return this.updateHotspot(hotspot);
                 }
            );
        }

        public getHotspotPromise(href: string): ng.IPromise<Hotspot> {
            return this.backendService
                .get(href)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<Hotspot>>) => {
                    let halElement: IHalElement<Hotspot> = data.data;
                    let converted: Hotspot = HalConverter.convertElement(halElement, Hotspot.Empty);
                    return this.burnishHotspot(converted);
                });
        }

        public getHotspotPromiseById(hotspotId: number): ng.IPromise<Hotspot> {
            return this.backendService
                .get(this.backendUrl + "/" + hotspotId)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<Hotspot>>) => {
                    let halElement: IHalElement<Hotspot> = data.data;
                    let converted: Hotspot = HalConverter.convertElement(halElement, Hotspot.Empty);
                    return this.burnishHotspot(converted);
                });
        }


        private burnishHotspot(element: Hotspot): Hotspot {
            // placeholder, nothing to do now
            return element;
        }
    }
}